export const DEVICE_STATUS_SORT_RANK: Readonly<Record<string, number>> = {
  ACTIVE: 0,
  PENDING: 1,
  ON_HOLD: 1,
  TOWER_ONLY: 1,
  BEING_UPDATED: 1,
  UNKNOWN: 1,
  INACTIVE: 2,
  DECOMMISSIONED: 2,
};

export function deviceStatusSortRank(status?: string | null): number {
  return DEVICE_STATUS_SORT_RANK[status ?? 'UNKNOWN'] ?? DEVICE_STATUS_SORT_RANK['UNKNOWN'];
}
